// extracted by mini-css-extract-plugin
export default {"backgroundColor":"deck-with-analysis_backgroundColor__YcOvz"};